import { render } from "./home.vue?vue&type=template&id=5ef97f96&scoped=true"
import script from "./home.vue?vue&type=script&lang=ts"
export * from "./home.vue?vue&type=script&lang=ts"

import "./home.vue?vue&type=style&index=0&id=5ef97f96&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5ef97f96"

export default script